module.exports = __webpack_public_path__ + "img/inspirational-motivator.f4406480.svg";